// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 397) return "content/plugin-aeapps-resources-manager/ec537ade9f29747313dea93477e2dcb2.js";
	// return url for filenames based on template
	return undefined;
};